import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    height: 162,
    marginTop: 7,
    marginHorizontal: -16,
  },
  customCardStyle: index => ({
    marginLeft: index == 0 ? 16 : 0,
    height: 125,
  }),
  addCardContainerStyle: {
    marginRight: 16,
    flex: 1,
    width: null,
  },
});
